import { render, staticRenderFns } from "./permissionMenu.vue?vue&type=template&id=7ea37488"
import script from "./permissionMenu.vue?vue&type=script&lang=js"
export * from "./permissionMenu.vue?vue&type=script&lang=js"
import style0 from "./permissionMenu.vue?vue&type=style&index=0&id=7ea37488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports